import styled from "styled-components";
import {
  colors,
  getTypographyFontStyle,
  device,
} from "../../styles/global.style";

const Heading = styled.h1`
  color: ${(props) => props.color || colors.lightdark};
  ${(props) =>
    getTypographyFontStyle({
      variant: props.as === "h2" ? "subtitle2" : "h1",
      weight: 500,
    })};

  letter-spacing: ${(props) => (props.as === "h2" ? "-0.28px" : "-1.2px")};
  margin: ${(props) => (props.as === "h2" ? "0 0 10px" : "0px")};

  @media ${device.md} {
    margin: ${(props) => (props.as === "h2" ? "0 0 20px" : "0px")};
    letter-spacing: ${(props) => (props.as === "h2" ? "-0.56px" : "-2.4px")};
  }
`;

export default Heading;
